import * as Yup from "yup";
import {BoulderWorkOrderCementUsed, BoulderWorkOrderCrewMember} from "./BoulderWorkOrderSchema";

export const BoulderForemanWorkOrderMaterialUsedSchema = Yup.object().shape({
    id: Yup.number().required(),
    job_detail_id: Yup.number().required(),
    cement_used: Yup.array().of(BoulderWorkOrderCementUsed).nullable(),
    pieces_of_half_inch_steel_used: Yup.number().nullable(),
    pieces_of_three_eighths_inch_steel_used: Yup.number().nullable(),
    coloring_used: Yup.string().nullable(),
    waterproofing_used: Yup.string().nullable(),
    yards_of_gunite_shot: Yup.number().nullable(),
    is_material_section_complete: Yup.boolean()
})

export const BoulderForemanWorkOrderDriversTimesSchema = Yup.object().shape({
    id: Yup.number().required(),
    job_detail_id: Yup.number().required(),
    driver_name: Yup.string().nullable(),
    driver_in: Yup.string().nullable(),
    on_job: Yup.string().nullable(),
    break_start: Yup.string().nullable(),
    break_end: Yup.string().nullable(),
    leave_job: Yup.string().nullable(),
    driver_out: Yup.string().nullable(),
    is_drivers_times_section_complete: Yup.boolean()
})

export const BoulderForemanWorkOrderCrewMembersSchema = Yup.object().shape({
    id: Yup.number().required(),
    job_detail_id: Yup.number().required(),
    crew_members: Yup.array().of(BoulderWorkOrderCrewMember).nullable(),
    is_crew_section_complete: Yup.boolean()
})

export const BoulderForemanWorkOrderForemanNotesSchema = Yup.object().shape({
    id: Yup.number().required(),
    job_detail_id: Yup.number().required(),
    problems_needing_attention: Yup.string().nullable(),
    work_done_today: Yup.string().nullable(),
    is_foreman_notes_section_complete: Yup.boolean()
})
